const headerData = {
  tableName: 'Application Status',
  hasExport: false,
  hasSearch: false,
  hasDelete: false,
  hasEdit: false,
  hasPaging: true,
  hasCheckbox: false,
  hasUploadCSV: false,
  hasFilter: false,
  isExpandable: true,
  fields: [
    { fieldName: 'text', headerName: 'Question' },
    { fieldName: 'country', headerName: 'Country' },
    {
      fieldName: 'dateCreated',
      headerName: 'Date',
      isDatetime: true,
    },
  ],
};
export default headerData;
